export default [
	{id: 'xsm', width: 240},
	{id: 'sm', width: 320},
	{id: 'md', width: 640},
	{id: 'lg', width: 960},
	{id: 'xlg', width: 1200}
];
